import React from 'react';
import { Form, Input, Button } from 'antd';
import { PlusOutlined, MinusOutlined } from '@ant-design/icons';
import { parseStringOr } from '../../App/AppxUtils';

import './index.css';


export default function InputInteger(props) {
    const name = parseStringOr(props.name, "");

    if (name === "") {
        throw new Error('Name is required!');
    }

    const min = isNaN(props.min) ? -2147483648 : props.min;
    const max = isNaN(props.max) ? 2147483647 : props.max;
    const onMinus = () => {
        let v = props.formRef.current.getFieldValue(name);
        v = parseInt(v) || 0;
        v --;

        if (v < min) {
            v = min;
        }

        props.formRef.current.setFieldsValue({[name]: v});

        if (typeof props.onChange === "function") {
            props.onChange(name, v);
        }
    };
    const onPlus = () => {
        let v = props.formRef.current.getFieldValue(name);
        v = parseInt(v) || 0;
        v ++;

        if (v > max) {
            v = max;
        }


        props.formRef.current.setFieldsValue({[name]: v});

        if (typeof props.onChange === "function") {
            props.onChange(name, v);
        }
    };
    const onChange = (e) => {
        let v = parseInt(e.target.value) || 0;

        if (v < min) {
            v = min;
        }
        else if (v > max) {
            v = max;
        }

        props.formRef.current.setFieldsValue({[name]: v});

        if (typeof props.onChange === "function") {
            props.onChange(name, v);
        }
    };

    let className = null;
    let addonBefore = null;
    let addonAfter = null;

    if (props.buttons !== false) {
        className = 'custom-input-integer';
        addonBefore = (<Button size={props.size} onClick={onMinus}><MinusOutlined /></Button>);
        addonAfter = (<Button size={props.size} onClick={onPlus}><PlusOutlined /></Button>);
    }

    return (
        <Form.Item
            name={name}
            label={props.label}
            rules={props.rules}
            className={className}
            style={props.style}
        >
            <Input
                type="text"
                placeholder={props.placeholder}
                size={props.size}
                addonBefore={addonBefore}
                addonAfter={addonAfter}
                disabled={props.disabled}
                onChange={onChange}
                onPressEnter={e => e.preventDefault()}
            />
        </Form.Item>
    );
}

